import HomeworkTable from '@/components/organisms/Table/HomeworkTable';
import { Icon } from '@/icons';
import { useState } from 'react';

export default function AcademyHomeworkList() {
  const [showOnlyAvailable, setShowOnlyAvailable] = useState(false);

  const handleToggleAvailable = () => {
    setShowOnlyAvailable(!showOnlyAvailable);
  };
  return (
    <main className='flex flex-1 pt-8 w-full md:py-5 md:bg-transparent'>
        <div className='flex-1 w-full'>
            <h1 className='px-5 pb-3 heading1'>숙제</h1>
            <HomeworkTable type='academy'/>
        </div>
    </main>
  )
}